/**
 * L2-R7: moved to @miq/platform-ui (lib/pipes/data-cell-formatter.pipe.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform-ui'.
 *
 * It had to move: it was the reports remote's biggest template coupling to the host — 16
 * reports/pdf-view files imported it and ~26 `| dataCellFormatter` bindings use it, so the remote
 * bundled its own copy of the pipe and of the column/LOV/date-format helpers behind it.
 */
export { DataCellFormatterPipe, dateSanitizer } from '@miq/platform-ui';
